var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInjured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7,
    r: 6.5,
    fill: "white",
    stroke: "#C8102E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2348_8215)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91205 6.41199V2.79999H8.08805V6.41199H11.7V7.58799H8.08805V11.2H6.91205V7.58799H3.30005V6.41199H6.91205Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2348_8215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.4,
    height: 8.4,
    fill: "white",
    transform: "translate(3.30005 2.79999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInjured);
export default __webpack_public_path__ + "static/media/icon-injured.8c19813543adf44556c94a984f8266d1.svg";
export { ForwardRef as ReactComponent };